import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {UniqueIdService} from "../../services/UniqueIdService";
import {RadioSharedQuestion} from "../../sharedQuestions/RadioSharedQuestion";
import {SharedQuestion} from "../../sharedQuestions/SharedQuestion";

export class RadioQuestionComponent implements ng.IComponentController {

    protected rootScope:IRootScope;
    protected timeout:ng.ITimeoutService;
    protected translate:ng.translate.ITranslateService;
    protected uniqueIdService:UniqueIdService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;
    protected questionTypesComponentsConst:IQuestionTypesConst;

    sharedQuestion:SharedQuestion;

    question:IQuestion;
    preventNextQuestion:string = 'false';
    nextQuestionCallback;
    value:string;
    otherValue:string;
    dontKnow:boolean;

    private previousValue:string;
    private popoverTimeout:ng.IPromise<any>;

    choices:string[] = [];
    /**
     * Supported styles: default, buttons, buttons-small
     * @type {string}
     */
    style:string     = 'default';
    ids:string[]     = [];

    hasOther:boolean|string = false;
    hasBigRadioStyle        = false;
    hasSmallRadioStyle      = false;

    static $inject = ['$rootScope', '$timeout', '$translate', 'UniqueIdService', 'SharedQuestionService', 'SessionService', 'QUESTION_TYPES_COMPONENTS'];

    constructor($rootScope:IRootScope, $timeout:ng.ITimeoutService, $translate:ng.translate.ITranslateService, UniqueIdService:UniqueIdService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService, QUESTION_TYPES_COMPONENTS) {
        this.rootScope                    = $rootScope;
        this.timeout                      = $timeout;
        this.translate                    = $translate;
        this.uniqueIdService              = UniqueIdService;
        this.sharedQuestionService        = sharedQuestionService;
        this.sessionService               = sessionService;
        this.questionTypesComponentsConst = QUESTION_TYPES_COMPONENTS;
    }

    public $onInit = () => {
        this.sharedQuestion = new RadioSharedQuestion();

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let choices = this.question.meta.choices;
        if (choices) {
            this.choices = choices;
        }

        let defaultValue = this.question.meta.default;
        if (defaultValue) {
            this.value = defaultValue;
            this.update();
        }

        let style = this.question.meta.style;
        if (style) {
            this.style = style;
        }

        if (this.style) {
            this.hasBigRadioStyle   = this.style === 'buttons' || this.style === 'buttons-small';
            this.hasSmallRadioStyle = this.style === 'buttons-small';
        }

        this.hasOther = this.question.meta.other;

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            let value = answer.values[0];

            if (value) {
                let choice = value.choice;

                if (choice <= this.choices.length) {
                    this.value = this.choices[choice];
                }

                if (value.otherValue && this.hasOther) {
                    this.otherValue = value.otherValue;
                }

                // If choice is null, 'don't know' was selected
                if (choice == null) {
                    this.dontKnow = true;
                    this.toggleDontKnow();
                } else {
                    this.update();
                }
            }
        }

        for (let choice of this.choices) {
            this.ids.push(this.uniqueIdService.getUniqueId('radio-' + choice));
        }
    }

    public onKeyPress(e: KeyboardEvent) {
        if (e.key === ' ') {
            this.update();
        }
    }

    public update(preventDoubleClick = false) {
        this.dontKnow = false;

        let newValue:IValue = {
            choice: this.choices.indexOf(this.value),
            value : true
        };

        if (this.otherValue && this.hasOther) {
            newValue.otherValue = this.otherValue;
        }

        this.sharedQuestion.setValue(newValue);

        // if double click popover is disabled
        if (this.question.meta.popover === false) {
            return;
        }

        // if second click
        if (!preventDoubleClick && this.previousValue && this.value === this.previousValue) {
            this.hidePopover();
            this.nextQuestionCallback();
            return;
        }

        // if first click
        this.previousValue = this.value;

        // show popover
        if (!preventDoubleClick && this.preventNextQuestion !== 'true') {
            this.hidePopover();

            if (!this.rootScope.radioQuestionSecondClickPopover) {
                this.rootScope.radioQuestionSecondClickPopover = 0;
            }

            if (this.rootScope.radioQuestionSecondClickPopover++ > this.questionTypesComponentsConst.maxSecondClickPopovers) {
                return;
            }

            let id      = this.ids[this.choices.indexOf(this.value)],
                element = angular.element('label[for=' + id + '] .inside');

            this.translate('radio_second_click_popover').then((translated) => {
                element.popover({
                    content  : translated,
                    placement: 'top'
                }).popover('show');

                // hide popup after some time
                this.popoverTimeout = this.timeout(() => {
                    element.popover('hide');
                }, 3000);
            });
        }
    }

    public toggleDontKnow() {
        this.value = null;
        this.previousValue = this.value;
        let newValue:IValue = null;

        if (this.dontKnow) {
            newValue = {
                choice: null,
                value : true
            };
        }

        this.sharedQuestion.setValue(newValue);
    }

    hidePopover() {
        this.timeout.cancel(this.popoverTimeout);

        for (let id of this.ids) {
            angular.element('label[for=' + id + '] .inside').popover('hide');
        }
    }

}

app.component('radioQuestion', {
    templateUrl : 'templates/components/questionTypes/radioQuestion.html',
    controller  : RadioQuestionComponent,
    controllerAs: 'radioQuestion',
    bindings    : {
        question            : '<',
        nextQuestionCallback: '&',
        preventNextQuestion : '@'
    }
});